<div class="content-1920">
  <div class="content-padding margin-top-small">
    <div class="main">
      <h2>Harvester Details</h2>
      <fieldset>
        <fieldset>
          <div class="fieldwrap label-inline">
            <label>Harvester Model</label>
            <select
              id="model"
              name="model"
              #model="ngModel"
              [(ngModel)]="harvester.model_id"
              (change)="changeModel(model.value)"
            >
              @for (e of harvesterModels; track e) {
              <option value="{{ e.id }}">
                {{ e.model_name }}
              </option>
              }
            </select>
          </div>
        </fieldset>
        <fieldset>
          <div class="fieldwrap label-inline">
            <label>Primary Extractor Fan</label>
            <select
              id="extractor_fan_config_id"
              name="extractor_fan_config_id"
              #model="ngModel"
              [(ngModel)]="harvester.extractor_fan_config_id"
            >
              @for (e of extractorFans; track e) {
              <option value="{{ e.id }}">
                {{ e.brand_name }} {{ e.name }}
              </option>
              }
            </select>
          </div>
          <div class="fieldwrap label-inline">
            <label>Wheels/Tracks</label>
            <select
              id="wheels_tracks"
              name="wheels_tracks"
              #wheels_tracks="ngModel"
              [(ngModel)]="harvester.undercarriage"
            >
              @for (e of wheelTrackOptions; track e) {
              <option value="{{ e }}">
                {{ e | titlecase }}
              </option>
              }
            </select>
          </div>
          <div class="fieldwrap label-inline">
            <label>Manufactured Year</label>
            <input
              type="number"
              min="1900"
              max="2100"
              step="1"
              [(ngModel)]="current_manufactured_date"
            />
            <!-- <select
            id="manufactured_date"
            name="manufactured_date"
            #model="ngModel"
            [(ngModel)]="current_manufactured_date"
            >
            <option *ngFor="let e of years">{{ e }}</option>
          </select> -->
          </div>
          <div class="fieldwrap label-inline">
            <label>Feedtrain Setup</label>
            <select
              id="feedtrain_setp"
              name="feedtrain_setp"
              #feedtrain_setp="ngModel"
              [(ngModel)]="harvester.feedtrain_setup"
            >
              @for (e of feedtrainOptions; track e) {
              <option value="{{ e }}">
                {{ e | titlecase }}
              </option>
              }
            </select>
          </div>
          <!--
            Per-instance row_type (SRA003-389): relocated from the calc-page
            modal. Three options; "Not set" persists as null so the BE can
            fall back through the resolution chain (instance > model > default).
          -->
          <div class="fieldwrap label-inline">
            <label>Row Type</label>
            <select
              id="row_type"
              name="row_type"
              [(ngModel)]="harvester.row_type"
            >
              <option [ngValue]="null">Not set</option>
              <option [ngValue]="'SINGLE_ROW'">Single row</option>
              <option [ngValue]="'DOUBLE_ROW'">Double row</option>
            </select>
          </div>
        </fieldset>
      </fieldset>
      <div class="fieldwrap fieldwrap-type-submit align-right">
        <a class="btn__secondary btn-back" routerLink="/harvesters">Back</a>
        <button class="btn-save" type="submit" (click)="save()">Save</button>
        <!-- <button class="btn-continue" type="submit">Save & Continue</button> -->
      </div>
      @if (id && harvester) {
      <div>
        <app-harvester-season
          [harvesterData]="harvester"
          [harvesterId]="id"
        ></app-harvester-season>
      </div>
      }
      <!-- SRA003-457: OEM machine → harvester linkage, shared with the
           per-provider Integrations manage view (same endpoints/store). -->
      <app-harvester-oem-link-section
        [preselectHarvesterId]="harvesterDbId"
      ></app-harvester-oem-link-section>
    </div>
  </div>
</div>
